import React, { Fragment } from 'react'
import StatusItem from '../status-card/status-item/status-item'
import { ProcessFlowItemInterface } from '../../models/interfaces/process-flow-item.interface'
import useIsMobile from '../../hooks/use-is-mobile'


interface ProcessFlowProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  items?: ProcessFlowItemInterface[],
  activeStep?: number,
}

const getAdditionalClassName = (isFirst: boolean, isLast:boolean) => {
  if(isFirst){
    return "polymer-process-flow-mobile__status_flow_line_first";
  }else if(isLast){
    return "polymer-process-flow-mobile__status_flow_line_last";
  }else{
    return "";
  }
}

function ProcessFlow({ items = [], activeStep = 1, ...props }: ProcessFlowProps) {
  const { isMobile } = useIsMobile();
  if(!isMobile){
    return (
      <div tabIndex={0} className='polymer-process-flow-container'>
        <div className='polymer-process-flow-title-container'>
          <p className='polymer-process-flow-title'>Process</p>
          <p className='polymer-process-flow-title'>Required Information</p>
        </div>
        <div className='polymer-process-flow'>
          {
            items.map((item, _index) => {
              const isActive = _index <= activeStep - 1
              const variant = item.variant ?? (isActive ? "default_horizontal" : "dot")
              const key = _index;
              
              return (
                <Fragment key={key}>
                  <div className='polymer-process-flow__icon-wrapper'>
                    {item.icon}
                  </div>
                  <p className="polymer-process-flow__step">{`Step ${_index + 1}`}</p>
                  <p className="polymer-process-flow__text polymer-process-flow__text-title">{item.title}</p>
                  <div className="polymer-process-flow__line-container">
                    {items?.length - 1 !== _index && <div className={'polymer-process-flow__line-container-separator'} />}
                    <StatusItem variant={variant} isActive={isActive} color="#0C8188"/>
                  </div>
                  {/* <p className="polymer-process-flow__text">{item.description}</p> */}
                  <span className="polymer-process-flow__text">{item.description}</span>
                  <p style={{ margin: 0, fontSize: 14, opacity: activeStep - 1 >= _index ? 1 : 0.5 }}>{item.duration}</p>
                </Fragment>
              )
            })
          }


        </div>
      </div>
    )
  }else{
    return (
      <div className="polymer-process-flow-mobile">
        {items.map((item, _index) => {
          const isActive = _index <= activeStep - 1;
          const isFirst = _index === 0;
          const isLast = _index === items.length - 1;
          const variant =
            item.variant ?? (isActive ? "default_horizontal" : "dot");
          const key = _index;

          return (
            <div className="d-flex" key={key} style={{ marginLeft: 47 }}>
              <div className="polymer-process-flow-mobile__status">
              <StatusItem
                  variant={variant}
                  isActive={isActive}
                  color="#0C8188"
                />
                 <div className={`polymer-process-flow-mobile__status_flow_line polymer-process-flow-mobile__status_flow_line ${getAdditionalClassName(isFirst, isLast)}`}></div>
              </div>
              <div className="polymer-process-flow-mobile__content-container">
                <div className="polymer-process-flow__icon-wrapper">
                  {item.icon}
                </div>
                <p className = "polymer-process-flow-mobile__step">{`Step ${_index + 1}`}</p>
                <p className = "polymer-process-flow-mobile__title">{item.title}</p>
                <div className = "polymer-process-flow-mobile__separator"></div>
                 <ul>
                    {item.descriptionMobile.map((desc, descIndex) => {
                      const key = `description-${descIndex}`;
                      return <li key={key}>{desc}</li>
                    })}
                 </ul>
             
                <p
                  style={{
                    margin: 0,
                    fontSize: 14,
                    opacity: activeStep - 1 >= _index ? 1 : 0.5,
                  }}
                >
                  {item.duration}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default ProcessFlow